export interface Link {
  label: string;
  url: string;
  id?: string;
}
